import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, RouterStateSnapshot } from "@angular/router";
import { AuthenticationService } from "./../../services/authentication.service";
import { ACLService } from '../../services/acl.service';
import { SocketIoService } from '../../services/socketio.service';

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate, CanLoad {
    constructor(private _router: Router, private _authService: AuthenticationService, private _aclService: ACLService,private _socketService:SocketIoService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const status = this._authService.isLoggedIn();
        if (!status) {
            sessionStorage.clear();
            this._router.navigate(["/authentication/login"]);
        }else{
            this._aclService.initUserPermissionData();
            this._socketService.setupSocketConnection();
        }
        return status;
    }

    canLoad(route: Route): boolean {

        const url = route.path;
        if (url.includes('daily-sales')) {

            if (this._authService.userInfo.accessControl?.isDailySales) {
                return true;
            } else {
                this._router.navigate(["/authentication/login"]);
                return false;
            }

        }
        return true;
    }
}
